<script setup lang="ts">
import { LEAD_STATUS, LEAD_STATUS_LABELS } from '@/constants/LeadStatus'

defineProps(['params'])
</script>

<template>
  <div :class="{
    'flex items-center gap-2': true,
    'w-full': !params.fitWidth,
    'w-fit': params.fitWidth,
    }">
    <div class="w-fit">
      <span
        :class="{
          'badge bg-neutral-100': params.data.status === LEAD_STATUS.WAITING,
          'badge bg-blue-100': params.data.status === LEAD_STATUS.ACCEPTED,
          'badge bg-emerald-100': params.data.status === LEAD_STATUS.WON,
          'badge bg-red-100': params.data.status === LEAD_STATUS.LOST || params.data.status === LEAD_STATUS.REFUSED,
        }"
      >
        {{ LEAD_STATUS_LABELS[params.data.status as keyof typeof LEAD_STATUS_LABELS] || params.data.status }}
      </span>
    </div>
  </div>
</template>

<style scoped></style>
